<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="698px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      v-loading="loading"
      ref="customerGroupForm"
      :model="customerGroup"
      label-position="top"
      :rules="rules"
    >
      <el-form-item
        label="Név"
        prop="name"
      >
        <el-input
          v-model="customerGroup.name"
        />
      </el-form-item>
      <el-form-item
        prop="customer"
        label="Vevő"
      >
        <el-select
          v-model="customerGroup.customers"
          style="width: 100%;"
          value-key="id"
          filterable
          remote
          multiple
          :remote-method="searchPartners"
          :loading="partnerLoading"
          placeholder="Írd be a partner nevét a kereséshez..."
        >
          <el-option
            v-for="customer in customers"
            :key="customer.id + 'customer'"
            :value="customer"
            :label="`#${customer.id} ${customer.company.name}`"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleClose">
        Mégse
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['type', 'customerGroupId'],
  data() {
    return {
      loading: false,
      buttonLoading: false,
      customers: [],
      partnerLoading: false,
      customerGroup: {
        customers: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: 'Mező megadása kötelező',
            trigger: 'change'
          }
        ],
      },
    };
  },
  computed: {
    title() {
      if (this.type === 'add') {
        return 'Új vevőcsoport';
      } else if (this.type === 'update') {
        return 'Vevőcsoport módosítása';
      } else {
        return '';
      }
    },
    buttonText() {
      if (this.type === 'add') {
        return 'Hozzáadása';
      } else if (this.type === 'update') {
        return 'Módosítás';
      } else {
        return '';
      }
    },
  },
  async mounted() {
    this.loading = true;
    if (this.customerGroupId) {
      this.customerGroup = await this.$store.dispatch('customerGroup/fetch', this.customerGroupId);
      this.customers = JSON.parse(JSON.stringify(this.customerGroup.customers));
    }
    this.loading = false;
  },
  methods: {
    async searchPartners(query) {
      this.partnerLoading = true;
      if (!query) {
        this.customers = [];
      } else {
        const queryString = new URLSearchParams({
          name: query,
          is_customer: true,
        });
        this.customers = await this.$store.dispatch('partner/search', '?' + queryString.toString());
      }
      this.partnerLoading = false;
    },
    handleClose() {
      this.$confirm('Biztosan elveted a módosításokat?', {
        confirmButtonText: 'Igen',
        type: 'warning',
      })
        .then(() => {
          this.$router.replace('/data/customer-groups');
        })
        .catch(() => {
        });
    },
    async store() {
      this.$refs['customerGroupForm'].validate(async valid => {
        if (valid) {
          this.buttonLoading = true;
          try {
            const data = JSON.parse(JSON.stringify(this.customerGroup));
            data.customers = data.customers.map(c => c.id);
            if (this.type === 'add') {
              await this.$store.dispatch('customerGroup/create', data);
            } else if (this.type === 'update') {
              await this.$store.dispatch('customerGroup/update', data);
            }
            this.$store.dispatch('customerGroup/fetchAll');
            this.buttonLoading = false;
            this.$router.replace('/data/customer-groups');
          } catch (e) {
          }
          this.buttonLoading = false;
        }
      });
    }
  },
};
</script>

<style lang="scss">
  .customer-transfer {
    .el-transfer-panel {
      width: 280px;
      .el-checkbox.el-transfer-panel__item {
        display: block;
      }
    }
  }
</style>
